import { Injectable } from '@angular/core';
import { AbstractControlOptions, UntypedFormArray } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { InvestmentKnowledge1 } from '@app/forms/subscription/definition/interface/subscription';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: InvestmentKnowledge1 & { riskProfil: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<InvestmentKnowledge1 & { riskProfil: any }> = {
      ownerId: [entity.ownerId],
      userFirstName: [entity.userFirstName],
      userLastName: [entity.userLastName],
      riskProfil: this.formBuilder.group({
        knowMonetaryProduct: [
          !_.isNil(entity?.riskProfil?.knowMonetaryProduct)
            ? entity?.riskProfil?.knowMonetaryProduct
            : false,
        ],
        monetaryProduct: [entity?.riskProfil?.monetaryProduct || 'UNKNOWN'],
        investMonetaryProduct: [
          !_.isNil(entity?.riskProfil?.investMonetaryProduct)
            ? entity?.riskProfil?.investMonetaryProduct
            : false,
        ],
        monetaryProductManagementMode: [
          entity?.riskProfil?.monetaryProductManagementMode || 'YOURSELF',
        ],
        knowBond: [
          !_.isNil(entity?.riskProfil?.knowBond)
            ? entity?.riskProfil?.knowBond
            : false,
        ],
        bond: [entity?.riskProfil?.bond || 'UNKNOWN'],
        investBond: [
          !_.isNil(entity?.riskProfil?.investBond)
            ? entity?.riskProfil?.investBond
            : false,
        ],
        bondManagementMode: [
          entity?.riskProfil?.bondManagementMode || 'ADVISOR',
        ],
        knowStock: [
          !_.isNil(entity?.riskProfil?.knowStock)
            ? entity?.riskProfil?.knowStock
            : false,
        ],
        stock: [entity?.riskProfil?.stock || 'UNKNOWN'],
        investStock: [
          !_.isNil(entity?.riskProfil?.investStock)
            ? entity?.riskProfil?.investStock
            : false,
        ],
        stockManagementMode: [
          entity?.riskProfil?.stockManagementMode || 'ADVISOR',
        ],
        knowPrivateEquity: [
          !_.isNil(entity?.riskProfil?.knowPrivateEquity)
            ? entity?.riskProfil?.knowPrivateEquity
            : false,
        ],
        privateEquity: [entity?.riskProfil?.privateEquity || 'UNKNOWN'],
        investPrivateEquity: [
          !_.isNil(entity?.riskProfil?.investPrivateEquity)
            ? entity?.riskProfil?.investPrivateEquity
            : false,
        ],
        privateEquityManagementMode: [
          entity?.riskProfil?.privateEquityManagementMode || 'ADVISOR',
        ],
        knowScpi: [
          !_.isNil(entity?.riskProfil?.knowScpi)
            ? entity?.riskProfil?.knowScpi
            : false,
        ],
        scpi: [entity?.riskProfil?.scpi || 'UNKNOWN'],
        investScpi: [
          !_.isNil(entity?.riskProfil?.investScpi)
            ? entity?.riskProfil?.investScpi
            : false,
        ],
        scpiManagementMode: [
          entity?.riskProfil?.scpiManagementMode || 'ADVISOR',
        ],
        knowLifeInsurance: [
          !_.isNil(entity?.riskProfil?.knowLifeInsurance)
            ? entity?.riskProfil?.knowLifeInsurance
            : false,
        ],
        lifeInsurance: [entity?.riskProfil?.lifeInsurance || 'UNKNOWN'],
        investLifeInsurance: [
          !_.isNil(entity?.riskProfil?.investLifeInsurance)
            ? entity?.riskProfil?.investLifeInsurance
            : false,
        ],
        lifeInsuranceManagementMode: [
          entity?.riskProfil?.lifeInsuranceManagementMode || 'ADVISOR',
        ],
        knowDerivativeProducts: [
          !_.isNil(entity?.riskProfil?.knowDerivativeProducts)
            ? entity?.riskProfil?.knowDerivativeProducts
            : false,
        ],
        derivativeProducts: [
          entity?.riskProfil?.derivativeProducts || 'UNKNOWN',
        ],
        investDerivativeProducts: [
          !_.isNil(entity?.riskProfil?.investDerivativeProducts)
            ? entity?.riskProfil?.investDerivativeProducts
            : false,
        ],
        derivativeProductsManagementMode: [
          entity?.riskProfil?.derivativeProductsManagementMode || 'ADVISOR',
        ],
      }),
    };
    const form = this.formBuilder.group(formConfig, options);

    return form;
  }
  generate(entity: InvestmentKnowledge1[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
    });
  }
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  extract() {
    return this.form.value.owners;
  }
}
